import React from 'react'
import "./card.css"
const Card = (props) => {
  return (
    <div className='card' >
        <img loading='lazy' src={props.image} alt='project-image' />
    <div className='para'>
        <h3>{props.title}</h3>
        <p>{props.stack}</p>
    </div>
</div>
  )
}

export default Card